import * as Model from './state/stateExtension'
import { updateWidget } from './state/actions/widgetsActions'
import { isLinkExist, isWidgetsActive } from './state/actions/componentsActions'
import { toArray } from 'lodash'
import { browserHistory } from 'react-router'
import qs from 'qs'
import { union } from 'lodash'
//import { addTitolareUser } from './state/actions/stepActions'

/**
 * Utility functions that help with common tasks. Functions like extending widgets,
 * or filtering an object properties
 *
 * @module  Utils
 */
export const posProducts = {
  prodPersonaFisica: 'POS_PERSONA_FISICA_EASYNOLO',
  prodDittaInd: 'POS_DITTA_IND_EASYNOLO',
  prodAzienda: 'POS_AZIENDA_EASYNOLO'
}
export const fileTypes=['image/png','image/jpeg','image/gif','image/pjpeg','image/x-png','application/pdf'] //'image/bmp'
const getContextRoot = () => {
  const HAS_CONTEXT_ROOT = process.env.NODE_ENV === 'production'
  let contextRoot = ''

  if (HAS_CONTEXT_ROOT) {
    contextRoot = window.location.href.replace(`${window.location.origin}/`, '')
    contextRoot = `/${contextRoot.substr(0, contextRoot.indexOf('/'))}`
  }

  return contextRoot
}

export const getEnv = () => {
  const onbApiRoot =
    process.env.API_ROOT.replace('/onboarding', '') || location.origin

  const env = onbApiRoot
    .replace(/www\.(\w\w)-hype\.it/, '$1')
    .replace(/trust\.telecomitalia\.it/, 'pp')
    .replace(/hype\.localdomain/, 'pp')
    .replace('te', 'tst')
    .replace('pp', 'pre')
    .replace(/www\.hype\.it/, 'pro')
    .replace(/https?:\/\//, '')

  return env
}

export const CONTEXT_ROOT = getContextRoot()
export const MAX_IMAGE_UPLOAD_SIZE = 1024

export const pushRoute = (route, mergeWithOldQs, ignoreKeys = []) => {
  const routeChunks = route.split('?')

  const routePath = routeChunks[0]

  const newParams = qs.parse(routeChunks[1] || '')

  const oldParams = mergeWithOldQs
    ? qs.parse(window.location.search, { ignoreQueryPrefix: true })
    : {}

  const filteredOldParams = ignoreKeys.reduce(
    (res, ik) => ({ ...res, [ik]: undefined }),
    oldParams
  )

  const queryObj = { ...filteredOldParams, ...newParams }

  Object.keys(queryObj).forEach(k => {
    if (queryObj[k] === '0') {
      delete queryObj[k]
    }
  })

  const queryString = !!queryObj ? `?${qs.stringify(queryObj)}` : ''

  browserHistory.push(`${CONTEXT_ROOT}${routePath}${queryString}`)
}

const POS_EASYNOLO = {
  POS_PERSONA_FISICA_EASYNOLO: {
    s1: 'contact-info',
    s2: 'address-info',
    s3: 'legal-info',
    s4: 'pos',
    s5: 'identification',
    s6: 'contract',
    s7: 'thanks'
  },
  POS_DITTA_IND_EASYNOLO: {
    s1: 'contact-info',
    s2: 'address-info',
    s3: 'company-info',
    s4: 'legal-info',
    s5: 'pos',
    s6: 'identification',
    s7: 'contract',
    s8: 'thanks'
  },
  POS_AZIENDA_EASYNOLO: {
    s1: 'contact-info',
    s2: 'address-info',
    s3: 'company-info',
    s4: 'legal-info',
    s5: 'identification',
    s6: 'pos',
    s7: 'contract',
    s8: 'thanks'
  }
}

export const isValidStep = (step, product) => {
  const productCode = product.prodCode
  return (
    POS_EASYNOLO[productCode] &&
    step < Object.keys(POS_EASYNOLO[productCode]).length
  )
}

export const getStepSlug = (step, product, state) => {
  let sCode = ''
  const isDirectThankPage = step.number === 1 && step.name === 'thanks'
  const productCode = isDirectThankPage
    ? state && state.routing.partnership
    : product.prodCode
  if (productCode && POS_EASYNOLO[productCode]) {
    if (isDirectThankPage) {
      const stepValues = Object.values(POS_EASYNOLO[productCode])
      sCode = stepValues[stepValues.length - 1]
    } else {
      sCode = POS_EASYNOLO[productCode][`s${step.number}`]
    }
  }
  return sCode
}

export const getProductCode = (step, product, state) => {
  let pCode = product.prodCode
  const isDirectThankPage = step.number === 1 && step.name === 'thanks'
  pCode = isDirectThankPage
    ? state && state.routing.partnership
    : (pCode && POS_EASYNOLO[pCode] && pCode) || ''
  return pCode
}

export const getActorSlug = step => {
  if (!!step.isUnderage) return '-underage'

  if (!!step.isParent) return '-parent'

  return ''
}

export const getFloodLightGroup = step => {
  const map = {
    s1: 'sella0',
    s2: 'banca0',
    s3: 'banca00',
    s4: 'step40',
    s5: 'step40',
    s6: 'typ_m0',
    s1u: 'sella0',
    s2u: 'step20',
    s3u: 'step30',
    s4u: 'step400',
    s5u: 'step50',
    s6u: 'typ_m00'
  }

  return map[`s${step.number}${step.isUnderage ? 'u' : ''}`] || ''
}

export const getFloodLightActivity = step => {
  const map = {
    s1: 'banca0',
    s2: 'banca0',
    s3: 'banca0',
    s4: 'banca0',
    s5: 'banca00',
    s6: 'banca0',
    s1u: 'banca0',
    s2u: 'banca0',
    s3u: 'banca0',
    s4u: 'banca0',
    s5u: 'banca0',
    s6u: 'banca0'
  }

  return map[`s${step.number}${step.isUnderage ? 'u' : ''}`] || ''
}

export const getUnderageQueryString = step => {
  return `?u=${!!step.isUnderage ? '1' : '0'}&p=${!!step.isParent ? '1' : '0'}`
}

/**
 * Checks if an entity is valid for the client
 * @param  {string} key         The entity key
 * @param  {Object} entities    The entities to check
 * @param  {Boolean} validate   Determines if the predicate should be used for error rendering
 * @return {string}             The component id
 */
export const isEntityInvalid = (key, entities) => {
  let res =
    entities[key].status.indexOf('hidden') < 0 &&
    entities[key].status.indexOf('error') > -1

  if (
    !entities[key].components &&
    !!entities.validations &&
    !!entities.validations.rules &&
    entities.validations.rules.length > 0
  ) {
    res = res && entities[key].type !== 'hidden' && !entities[key].isDisabled
    if (entities[key].type === 'radio') {
      res =
        res &&
        !Object.keys(entities).find(
          k =>
            k.indexOf(`${key.split('-')[0]}-`) > -1 &&
            entities[k].type === 'radio' &&
            entities[k].status.indexOf('error') < 0
        )
    }
  }

  return res
}

/**
 * Filters an object's properties
 * @public
 *
 * @param  {Object} obj           The source object
 * @param  {Function} predicate   The filter criteria
 * @return {Object}               The filtered object
 */
export const filterObject = (obj, predicate) => {
  const result = {}
  let key

  for (key in obj) {
    if (obj.hasOwnProperty(key) && predicate(obj[key])) {
      result[key] = obj[key]
    }
  }

  return result
}

/**
 * Gets the index of an object in an array
 * @param  {Array} myArray    The array to scan
 * @param  {string} searchTerm The search term
 * @param  {string} property   The property
 * @return {Number}            The resultant index
 */
export const arrayObjectIndexOf = (myArray, searchTerm, property) => {
  for (let i = 0, len = myArray.length; i < len; i++) {
    if (myArray[i][property] === searchTerm) return i
  }
  return -1
}

/**
 * Camelizes a string
 * @public
 *
 * @param  {string} str           The string you need to camelize
 * @param  {Boolean} onlyFirst    If we should set only the first character to uppercase
 * @param  {Boolean} avoidJoin    If we should join the string
 * @return {string}               The camelized string
 */
export const camelize = (str, onlyFirst, avoidJoin) => {
  if (typeof str !== 'string') return
  let pattern = /[\s_](.)/g
  if (onlyFirst) {
    pattern = /(.)/
  }

  let ret = str.toLowerCase().replace(pattern, $1 => {
    return $1.toUpperCase()
  })

  if (!avoidJoin) {
    ret = ret.replace(/\s/g, '')
  }

  return ret
}

/**
 * Returns the missing components for the passed widget seeking them into the stateExtension
 * @private
 *
 * @param {Object} widgets          The source widgets
 * @param {string} wk               The current widget key
 * @return {Array}                  The extended widget's components keys
 */
const getMissingWidgetComponentKeys = (widgets, wk) => {
  return Object.keys(Model.COMPONENTS).filter(
    ck =>
      !!widgets.NOME_COGNOME //@hack to avoid that legacy JOLLY_INPUT on step 1 gets populated with JOLLY_RADIO value
        ? ck.indexOf(`${widgets[wk].name}-`) > -1 &&
          ((!!Model.COMPONENTS[ck].extra && !ck.startsWith('JOLLY-')) ||
            (ck.startsWith('JOLLY-') && !Model.COMPONENTS[ck].extra))
        : ck.indexOf(`${widgets[wk].name}-`) > -1 &&
          !!Model.COMPONENTS[ck].extra
  )
}

/**
 * Integrates widget's missing metadata
 * @public
 * @todo   We can probably make it more concise
 *
 * @param  {Object} model                 The model to extend and persist
 * @param  {Object} oldModel              The old model
 * @param  {Object} config                The config for the extend model
 * @return {Object}                       The extended model
 */
export const extendModel = (model, oldModel, config) => {
  if (!model) return
  const WIDGETS = 'WIDGETS'
  const COMPONENTS = 'COMPONENTS'
  const modelType = model[Object.keys(model)[0]].code ? WIDGETS : COMPONENTS
  let extendedModel = model
  const tito = [
    'CODICE_FISCALE-DATADINASCITA',
    'CODICE_FISCALE-SESSO',
    'CODICE_FISCALE-PROVINCIADINASCITA',
    'CODICE_FISCALE-LUOGODINASCITA'
  ]

  const TYPES = {
    cf: 'codiceFiscale',
    nome: 'nome',
    cognome: 'cognome',
    datadinascita: 'dataDiNascita',
    sesso: 'sesso',
    luogodinascita: 'luogoDiNascita',
    provinciadinascita: 'provinciaDiNascita'
  }

  // @hack for the signaler
  /*if (modelType === WIDGETS && !!extendedModel.NOME_COGNOME) {
    if (!extendedModel.WHAT_YOU_NEED) {
      extendedModel.WHAT_YOU_NEED = {
        ...Model[modelType].WHAT_YOU_NEED
      }
    }
    if (!extendedModel.SIGNALER) {
      extendedModel.SIGNALER = { ...Model[modelType].SIGNALER }
    }
  }*/

  // @hack for the extra email verification
  if (modelType === WIDGETS && !!extendedModel.TIPOLOGIA_CARTA) {
    if (!extendedModel.VERIFICA_EMAIL_EXTRA) {
      extendedModel.VERIFICA_EMAIL_EXTRA = {
        ...Model[modelType].VERIFICA_EMAIL_EXTRA
      }
    }
  }

  const genericIndex =
    modelType === COMPONENTS
      ? [
          ...new Set([
            ...Object.keys(extendedModel),
            ...(!!Object.keys(extendedModel).find((
              k //@hack to avoid that legacy JOLLY_INPUT on step 1 gets populated with JOLLY_RADIO value
            ) => k.startsWith('NOME_COGNOME-'))
              ? Object.keys(Model[modelType]).filter(
                  k =>
                    !k.startsWith('JOLLY-') ||
                    (k.startsWith('JOLLY-') && !Model[modelType][k].extra)
                )
              : Object.keys(Model[modelType]))
          ])
        ]
      : Object.keys(extendedModel)
  const widgetsIndex =
    modelType === COMPONENTS
      ? [
          ...new Set([
            ...Object.keys(extendedModel).map(s => s.split('-')[0]),
            /*...(Object.keys(extendedModel).indexOf('PRIVACY-PRIVACY') > -1
            ? ['WHAT_YOU_NEED', 'SIGNALER']
            : []),*/
            ...(Object.keys(extendedModel).indexOf(
              'TIPOLOGIA_CARTA-CARTA_VIRTUALE'
            ) > -1
              ? ['VERIFICA_EMAIL_EXTRA']
              : [])
          ])
        ]
      : genericIndex
  genericIndex.forEach(k => {
    if (!!extendedModel[k]) {
      if (
        !!oldModel &&
        oldModel[k] &&
        (modelType === WIDGETS ||
          (oldModel[k].id && oldModel[k].id.indexOf('FLOW_BAR') < 0))
      ) {
        extendedModel[k].status = [
          ...new Set([...extendedModel[k].status, ...oldModel[k].status])
        ]
        extendedModel[k].errorMessage = [
          ...new Set([
            ...extendedModel[k].errorMessage,
            ...oldModel[k].errorMessage
          ])
        ]
      }

      if (modelType === WIDGETS) {
        extendedModel[k].components = [
          ...new Set([
            ...extendedModel[k].components,
            ...getMissingWidgetComponentKeys(extendedModel, k)
          ])
        ]
      }

      if (
        modelType === COMPONENTS &&
        widgetsIndex.some(s => s.indexOf(k.split('-')[0]) > -1)
      ) {
        extendedModel[k] = {
          ...extendedModel[k],
          ...Model[modelType][k],
          status: [
            ...new Set([
              ...extendedModel[k].status,
              !extendedModel[k].active && 'hidden'
            ])
          ].filter(e => !!e)
        }
      }
    } else {
      if (
        modelType === COMPONENTS &&
        widgetsIndex.some(s => s.indexOf(k.split('-')[0]) > -1) &&
        !!Model[modelType][k].extra
      ) {
        extendedModel[k] = {
          ...extendedModel[k],
          ...Model[modelType][k]
        }
      }
    }

    if (
      modelType === COMPONENTS &&
      !!extendedModel[k] &&
      (!extendedModel[k].validations ||
        extendedModel[k].validations.constructor.toString().indexOf('Array') >
          -1)
    ) {
      extendedModel[k].validations = {}
    }
  })

  // @hack for parent's radiobutton
  if (
    modelType === COMPONENTS &&
    !!extendedModel['JOLLY-JOLLY_INPUT'] &&
    !!extendedModel[
      `JOLLY-JOLLY_RADIO_${extendedModel['JOLLY-JOLLY_INPUT'].value}`
    ]
  ) {
    extendedModel[
      `JOLLY-JOLLY_RADIO_${extendedModel['JOLLY-JOLLY_INPUT'].value}`
    ].status = ['selected']
  }

  // @hack for residency permit
  if (
    modelType === COMPONENTS &&
    !!extendedModel['DOCUMENTO_2-PERMESSO_SOGGIORNO'] &&
    !!extendedModel['DOCUMENTO_2-PERMESSO_SOGGIORNO'].active
  ) {
    extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options =
      !!extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options
        ? extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options : {}

    extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options.url =
      'wgt/utils/tipologiaPermessoDiSoggiorno'

    extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].options.mapping = {
      label: 'label',
      value: 'value',
      enteEmissione: 'enteEmissione'
    }

    // if (config.name === 'Identificati') {
      extendedModel['DOCUMENTO_2-TIPO_DOCUMENTO'].position = 1
      extendedModel['DOCUMENTO_2-ENTE_RILASCIO'].position = 2
    // }
  }

  if (
    modelType === WIDGETS && !!config.isWebCamEnabled &&
    !!extendedModel['MOD_IDENTIFICAZIONE'] 
  ) {
    extendedModel['MOD_IDENTIFICAZIONE'].status = []
  }
  if(
    modelType === COMPONENTS && !!config.isWebCamEnabled &&
    !!extendedModel['MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO']
  ){
    extendedModel['MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO'].status =[]
    extendedModel['MOD_IDENTIFICAZIONE-SELFIE_1_DOCUMENTO'].type= 'radio'
  }

  if (
    modelType === COMPONENTS &&
    !!extendedModel['DOCUMENTO_2-DATA_SCADENZA'] &&
    !!oldModel &&
    !!oldModel['DOCUMENTO_2-DATA_SCADENZA']
  ) {
    extendedModel['DOCUMENTO_2-DATA_SCADENZA'].validations.isRequired =
      oldModel['DOCUMENTO_2-DATA_SCADENZA'].validations.isRequired
    extendedModel['DOCUMENTO_2-DATA_SCADENZA'].isDisabled =
      oldModel['DOCUMENTO_2-DATA_SCADENZA'].isDisabled
  }

  if (modelType === COMPONENTS) {
    const SETTORE_ATTIVITA_AZIENDA = [
      'SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA',
      'SETTORE_ATTIVITA_AZIENDA-SETTORE',
      'SETTORE_ATTIVITA_AZIENDA-TIPO_SOCIETA',
      'PROFESSIONE_ATTIVITA-PROFESSIONE',
      'PROFESSIONE_ATTIVITA-SETTORE',
      'PROFESSIONE_ATTIVITA-ATTIVITA'
    ]
    SETTORE_ATTIVITA_AZIENDA.map(k => {
      if (!!extendedModel[k] && !!oldModel && !!oldModel[k]) {
        // if (!extendedModel[k].value && oldModel[k].value) {
        //   extendedModel[k].value = oldModel[k].value
        // }
        // if (oldModel[k].value) {
        //   extendedModel[k].value = oldModel[k].value
        // }
        extendedModel[k].value = oldModel[k].value
        extendedModel[k].values = oldModel[k].values
      }
    })

    const SETTORE = extendedModel['SETTORE_ATTIVITA_AZIENDA-SETTORE']
    if (SETTORE && SETTORE.value) {
      const DETTAGLIO_ATTIVITA_ECONOMICA =
        extendedModel['SETTORE_ATTIVITA_AZIENDA-DETTAGLIO_ATTIVITA_ECONOMICA']
      if (
        DETTAGLIO_ATTIVITA_ECONOMICA &&
        DETTAGLIO_ATTIVITA_ECONOMICA.options
      ) {
        DETTAGLIO_ATTIVITA_ECONOMICA.options.init = true
      }
    }

    // const cell_component = extendedModel['CELLULARE-NUM_CELLULARE']
    // if (!!cell_component && config.product !== posProducts.prodPersonaFisica) {
    //   const validations = {}
    //   validations.isRequired = cell_component.validations.isRequired
    //   validations.default = cell_component.validations.default
    //   extendedModel['CELLULARE-NUM_CELLULARE'].validations = validations
    // }

    const tipoRoles = extendedModel['AZIENDA_ROLES-TIPO_ROLES_LINK_AZIENDA']
    if (!!tipoRoles && tipoRoles.rawValue && tipoRoles.rawValue.length) {
      const rawValue = tipoRoles.rawValue.filter(v => v.value !== -1)
      tipoRoles.values = rawValue.map(v => ({
        value: v.value,
        label: v.description
      }))
    }
  }

  /*  if (modelType === COMPONENTS && !!extendedModel['TITOLARE_ESERCITA-ADD']) {
    extendedModel['TITOLARE_ESERCITA-ADD'].action = addTitolareUser
  }
*/
  /** TODO: Have to fix this based on widget.radioGroup impl */
  // The following statement selects the first radio by default if none from it's widget is set
  /*if (modelType === COMPONENTS) {
    const radios = filterObject(extendedModel, obj => obj.type === 'radio')
    if (Object.keys(radios).length > 0) {
      const groupedRadios = Object.keys(radios)
        .filter(k => radios[k].status.indexOf('hidden') < 0)
        .reduce((obj, k) => {
          const groupKey = k.substr(0, k.indexOf('-'))
          if (!obj[groupKey]) {
            obj[groupKey] = {}
          }
          obj[groupKey][k] = radios[k]
          return obj
        }, {})

      Object.keys(groupedRadios).forEach(k => {
        if (
          Object.keys(groupedRadios[k]).every(
            k2 =>
              !groupedRadios[k][k2].value &&
              groupedRadios[k][k2].status.indexOf('selected') < 0
          )
        ) {
          const firstRadioId = Object.keys(groupedRadios[k]).reduce(
            (prev, curr) =>
              groupedRadios[k][curr].position < groupedRadios[k][prev].position
                ? groupedRadios[k][curr].id
                : groupedRadios[k][prev].id
          )
          extendedModel[firstRadioId].value = 'selected'
        } else {
          Object.keys(groupedRadios[k]).forEach(k2 => {
            if (
              !groupedRadios[k][k2].value &&
              groupedRadios[k][k2].status.indexOf('selected') > -1
            ) {
              groupedRadios[k][k2].value = 'selected'
            }
          })
        }
      })
    }
  }*/
  if (config && config.name && !config.name.startsWith('I titolari')) {
    if (modelType === WIDGETS) {
      const cf = extendedModel.CODICE_FISCALE
      if (!!cf && cf.components) {
        cf.components = cf.components.filter(k => tito.every(n => n !== k))
      }
    }
    if (modelType === COMPONENTS) {
      if (!!extendedModel) {
        const extendedModel_ = {}
        Object.keys(extendedModel).forEach(k => {
          if (tito.every(n => n !== k)) {
            extendedModel_[k] = extendedModel[k]
          }
        })
        extendedModel = extendedModel_
      }
    }
  }

  if (modelType === COMPONENTS && config && config.dispatch) {
    const entitiesWidgets = config.widgets
    const dispatch = config.dispatch
    Object.keys(extendedModel).map(k => {
      const o = extendedModel[k]
      const options = o.toggleVisibility
      if (
        (o.linkId || o.widgetName) &&
        options &&
        o.hasOwnProperty('toggleVisibility')
      ) {
        let visibility_ = true
        const isExist = !o.widgetName && isLinkExist(o.linkId, extendedModel)
        if (isExist) {
          visibility_ = true
        } else if (
          (o.type === 'selectbox' || o.type === 'text') &&
          o.value !== null
        ) {
          if (o.linkValues) {
            visibility_ = o.linkValues.some(v => v === o.value)
          } else {
            visibility_ = o.linkValue && o.linkValue === o.value
          }
        } else if (o.type === 'radio' || o.type === 'checkbox') {
          visibility_ = o.value === 'selected'
        }
        if (options) {
          Object.keys(options).forEach(visibility => {
            let isVisible = null
            const fields = options[visibility] && options[visibility].fields
            if (fields && fields.length > 0) {
              fields.forEach(field => {
                const isComponent = field.indexOf('-') > -1
                const extendedModel_ = isComponent
                  ? extendedModel[field]
                  : entitiesWidgets[field]
                if (extendedModel_.status) {
                  if (field === 'SZ0025') {
                    isVisible = 'true'
                  } else {
                    if (
                      isComponent ||
                      (config &&
                        config.step &&
                        !config.name.startsWith('Personalizza'))
                    ) {
                      isVisible =
                        visibility === 'show' ? visibility_ : !visibility_
                      //isVisible = visibility === 'show' && visibility_
                    } else {
                      const widget = entitiesWidgets[field]
                      if (widget) {
                        if (visibility === 'show') {
                          if (visibility_) {
                            isVisible =
                              widget.active ||
                              fields.some(f => f.startsWith(field + '-'))
                          } else {
                            isVisible =
                              widget.active && isWidgetsActive(widget, fields)
                          }
                        } else {
                          if (visibility_) {
                            isVisible =
                              widget.active && isWidgetsActive(widget, fields)
                          } else {
                            isVisible =
                              widget.active ||
                              fields.some(f => f.startsWith(field + '-'))
                          }
                        }
                      }
                    }
                  }
                  const updateBody = {}
                  if (isVisible) {
                    updateBody.status = extendedModel_.status.filter(
                      e => e !== 'hidden'
                    )
                    updateBody.active = true
                  } else if (!isVisible) {
                    updateBody.status = union(extendedModel_.status, ['hidden'])
                    updateBody.active = false

                    if (
                      extendedModel_.type === 'radio' ||
                      extendedModel_.type === 'checkbox'
                    ) {
                      updateBody.value =
                        extendedModel_.status.indexOf('selected') > -1
                          ? 'selected'
                          : ''
                    }
                  }
                  if (isComponent) {
                    extendedModel[field] = {
                      ...extendedModel_,
                      ...updateBody
                    }
                  } else {
                    dispatch(
                      updateWidget(field, updateBody, { collateral: true })
                    )
                  }
                }
              })
            }
          })
        }
      }
    })
  }

  // if (config && !!config.name.startsWith('I titolari')) {
  //   let dpdKey = null
  //   if (!!extendedModel['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA']) {
  //     //cehckinf for the componets which contains all the values and extracting the same
  //     const titoComp =
  //       extendedModel['TITOLARE_EFFETTIVO-TITOLARE_EFFETTIVO_DATA']
  //     if (
  //       titoComp &&
  //       titoComp.rawValue &&
  //       titoComp.rawValue.titolare_effettivo[0]
  //     ) {
  //       const titoValue = titoComp.rawValue.titolare_effettivo[0]

  //       //Iterating the Components and Assigning the value
  //       Object.keys(extendedModel).forEach(k => {
  //         const comp = extendedModel[k]
  //         if (comp.id.startsWith('RESIDENZA-')) {
  //           dpdKey =
  //             comp.name === 'residenzaFiscale'
  //               ? 'residenzaFiscale'
  //               : comp.name.toLowerCase()
  //           comp.value = titoValue.residenza[dpdKey]
  //         }
  //         if (
  //           comp.id.startsWith('DOCUMENTO-') &&
  //           comp.name !== 'DOCR_UPLOAD' &&
  //           comp.name !== 'DOCF_UPLOAD'
  //         ) {
  //           comp.value = titoValue.documento[comp.name.toLowerCase()]
  //         }

  //         if (
  //           comp.id.startsWith('NOME_COGNOME-') ||
  //           comp.id.startsWith('CODICE_FISCALE-')
  //         ) {
  //           const dpdKey =
  //             comp.name === 'meseAnno' ? 'meseAnno' : comp.name.toLowerCase()
  //           const rezKey = TYPES[dpdKey]
  //           comp.value = titoValue.datiContatto[rezKey]
  //         }
  //         if (
  //           comp.refDataTeJsObj &&
  //           comp.refDataTeJsObj === 'indirectPepDetail'
  //         ) {
  //           dpdKey =
  //             comp.refDataTeJs === 'tipolegame'
  //               ? 'tipoLegame'
  //               : comp.refDataTeJs
  //           comp.value = titoValue.indirectPepDetail[dpdKey]
  //         }
  //         if (
  //           comp.refDataTeJsObj &&
  //           comp.refDataTeJsObj === 'directPepDetail'
  //         ) {
  //           dpdKey = comp.refDataTeJs
  //           comp.value = titoValue.directPepDetail[dpdKey]
  //         }
  //       })

  //       extendedModel['TITOLARE_DATA-EFFETTIVO_SI'].value =
  //         titoValue.legale_repre === 'SI' ? 'selected' : ''
  //       extendedModel['TITOLARE_DATA-EFFETTIVO_NO'].value =
  //         titoValue.legale_repre === 'SI' ? '' : 'selected'

  //       extendedModel['SZ0025-SS0052_DM0097_RI0022'].value =
  //         titoValue.directPep === 'SI' ? 'selected' : ''
  //       extendedModel['SZ0025-SS0052_DM0097_RI0023'].value =
  //         titoValue.directPep === 'SI' ? '' : 'selected'

  //       extendedModel['SZ0025-SS0163_DM0503_RI0568'].value =
  //         titoValue.indirectPep === 'SI' ? 'selected' : ''
  //       extendedModel['SZ0025-SS0163_DM0503_RI0569'].value =
  //         titoValue.indirectPep === 'SI' ? '' : 'selected'

  //       if (titoValue.directPepDetail.inCorso) {
  //         extendedModel['SZ0025-SS0162_DM0501_RI0565'].value =
  //           titoValue.directPepDetail.inCorso === 'SI' ? 'selected' : ''
  //         extendedModel['SZ0025-SS0162_DM0501_RI0566'].value =
  //           titoValue.directPepDetail.inCorso === 'SI' ? '' : 'selected'
  //       }
  //       if (titoValue.indirectPepDetail.inCorso) {
  //         extendedModel['SZ0025-SS0163_DM0507_RI0573'].value =
  //           titoValue.indirectPepDetail.inCorso === 'SI' ? 'selected' : ''
  //         extendedModel['SZ0025-SS0163_DM0507_RI0574'].value =
  //           titoValue.indirectPepDetail.inCorso === 'SI' ? '' : 'selected'
  //       }
  //     }
  //   }
  // }

  return extendedModel
}

/**
 * Integrates same step widget's missing metadata
 * avoiding data loss for previously asyncronously loaded select options or
 * checkboxes selection
 * @public
 *
 * @param  {Array} oldWidgets          The old widgets array
 * @param  {Array} freshWidgets        The new widgets array
 * @param  {Number} oldStepNumber      The old step number
 * @param  {Number} freshStepNumber    The new step number
 * @return {Array}                     The extended widget array
 */
export const initWidgets = (
  oldWidgets,
  freshWidgets,
  oldStepNumber,
  freshStepNumber
) => {
  if (oldStepNumber === freshStepNumber) {
    for (const w of freshWidgets) {
      for (const c of w.components) {
        if (c.type === 'selectbox') {
          c.values = oldWidgets
            .find(ow => ow.name === w.name)
            .components.find(oc => oc.name === c.name).values
        } else if (c.type === 'checkbox') {
          c.value = oldWidgets
            .find(ow => ow.name === w.name)
            .components.find(oc => oc.name === c.name).value
        }
      }
    }
  }
  return freshWidgets
}

/**
 * Removes widget's additional metadata
 * @public
 *
 * @param  {Array} widgets      The widgets array
 * @param  {Array} components   The components array
 * @return {Array}              The compressed widget array without the flowbar
 */
export const compressWidgets = (widgets, components) => {
  return toArray(
    filterObject(widgets, w => Number(w.code) > 0 && !w.extra && w.name!=='PROMO')
  ).map(w => (
    {
    code: w.code,
    name: w.name.replace(`_${w.code}`, ''),
    components: w.components.filter(k => !!components[k] && !components[k].extra).map(c => ({ //solving undefined error  - by Fahim
      name: components[c].name,
      value: components[c].value
    }))
  }))
}

/**
 * Converts a base64 string into a blob
 *
 * @param  {string} b64Data     The base64 string
 * @param  {string} contentType The file content type
 * @param  {Number} sliceSize   The slice size
 * @return {Byte[]}             The converted bytes array
 */
export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

/**
 * Checks if none of the radios relative to the passed componentId is selected
 *
 * @param  {Object}  components  The components
 * @param  {string}  componentId The component id
 * @param  {Object}  widget      The widget
 * @return {Boolean}             The result
 */
export const isNoRadioSelected = (components, componentId, widget) => {
  const component = components[componentId]
  let radioGroup = null
  if (widget && widget.radioGroup) {
    const parentId = widget.radioGroup[component.id_]
    radioGroup = Object.keys(widget.radioGroup).filter(
      k => widget.radioGroup[k] === parentId
    )
  }
  let keys = Object.keys(components).filter(k => components[k].type === 'radio')
  if (widget && radioGroup) {
    keys = keys.filter(k => radioGroup.some(id_ => id_ === components[k].id_))
  } else {
    keys = keys.filter(k => k.indexOf(componentId.split('-')[0]) > -1)
  }
  let noneSelected = true

  for (const k of keys) {
    noneSelected = noneSelected && components[k].value === ''
    if (!noneSelected) {
      return noneSelected
    }
  }
  return noneSelected
}

/**
 * Checks if the provided cf belongs to an eligible user
 *
 * @param  {string} cf         The CF
 * @param  {Number} userAge    The user's age
 * @return {Boolean}           The result
 */
export const cfBelongsToEligibleUser = (cf, userAge) => {
  userAge = userAge || 18
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()

  let birthYear = Number(cf.replace(/\w\w\w\w\w\w(\d\d)\w\d\d\w\d\d\d\w/, '$1'))

  let century = parseInt(currentYear / 100) * 100

  if (birthYear > currentYear.toString().substr(2, 4)) {
    century = century - 100
  }

  birthYear = century + birthYear

  const age = currentYear - birthYear

  let isEligible = false

  if (age >= userAge) {
    if (age === userAge) {
      // checks month and day
      const monthsMap = {
        A: '01',
        B: '02',
        C: '03',
        D: '04',
        E: '05',
        H: '06',
        L: '07',
        M: '08',
        P: '09',
        R: '10',
        S: '11',
        T: '12'
      }

      const month =
        monthsMap[cf.replace(/\w\w\w\w\w\w\d\d(\w)\d\d\w\d\d\d\w/, '$1')]

      let day = Number(cf.replace(/\w\w\w\w\w\w\d\d\w(\d\d)\w\d\d\d\w/, '$1'))

      day = day > 40 ? day - 40 : day

      const birthDate = new Date(`${birthYear}-${month}-${day}`)

      const checkTimestamp = birthDate.setFullYear(
        birthDate.getUTCFullYear() + userAge
      )

      isEligible = checkTimestamp < currentDate.getTime()
    } else {
      isEligible = true
    }
  }

  return isEligible
}

/**
 * Checks if the provided cf belongs to an adult
 *
 * @param  {string} cf    The CF
 * @return {Boolean}      The result
 */
export const cfBelongsToAdult = cf => cfBelongsToEligibleUser(cf)

export const padNum = (n, width, z) => {
  z = z || '0'
  n = n + ''
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}

export const getBrowser = () => {
  const str = (() => {
    const ua = navigator.userAgent
    let tem
    let M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || []
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || []
      return 'MSIE ' + (tem[1] || '')
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
      if (tem !== null) {
        return tem
          .slice(1)
          .join(' ')
          .replace('OPR', 'Opera')
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
      M.splice(1, 1, tem[1])
    }
    return M.join(' ')
  })()
  return {
    name: str.match(/\w+/)[0],
    version: str.match(/\d+/)[0]
  }
}

export const isBrowserTooOld = () => {
  const browser = getBrowser()
  try {
    switch (browser.name.toLowerCase()) {
      case 'chrome':
        return Number(browser.version) < 41
      case 'firefox':
        return Number(browser.version) < 38
      case 'msie':
        return Number(browser.version) < 9
      case 'edge':
        return Number(browser.version) < 25
      case 'safari':
        return Number(browser.version) < 7
      case 'opera':
        return Number(browser.version) < 15
      default:
        return true
    }
  } catch (ex) {
    return true
  }
}
export const ios11Instructions=()=>{
  const browser=getBrowser()
  let instructions=''
  if(browser.name.toLowerCase()==='safari')
  {
   instructions='<div style="font-weight:bold;text-align: left;margin-left: 30px;margin-top: 15px;">Gentile Cliente, la preghiamo di riprovare dopo aver disabilitato l’opzione "Blocca tracciamento cross-site" nel modo seguente <div style="margin-left: 20px;"><p>1 Entrare in Impostazioni</p><p>2 Cliccare sull’icona Safari</p><p>3 Entrare nel tab Privacy e Sicurezza</p><p>4 Disabilitare l’opzione "Blocca tracciamento cross-site"</p></div></div>'
  }
  return instructions
}
export const resizeImage = (dataUri, maxSize) => {
  if (!dataUri) throw 'error: resizeImage requires dataUri argument'
  if (!maxSize) throw 'error: resizeImage requires maxSize argument'

  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')

    const image = new Image()
    image.src = dataUri

    image.onload = () => {
      const maxWidth = maxSize // Max width for the image
      const maxHeight = maxSize // Max height for the image
      let ratio = 0 // Used for aspect ratio
      let width = image.width // Current image width
      let height = image.height // Current image height

      canvas.width = width
      canvas.height = height

      // Check if the current width is larger than the max
      if (width > maxWidth) {
        ratio = maxWidth / width // get ratio for scaling image
        canvas.width = maxWidth // Set new width
        canvas.height = height * ratio // Scale height based on ratio
        height = height * ratio // Reset height to match scaled image
        width = width * ratio // Reset width to match scaled image
      }

      // Check if current height is larger than max
      if (height > maxHeight) {
        ratio = maxHeight / height // get ratio for scaling image
        canvas.height = maxHeight // Set new height
        canvas.width = width * ratio // Scale width based on ratio
        width = width * ratio // Reset width to match scaled image
        height = height * ratio // Reset height to match scaled image
      }

      canvas
        .getContext('2d')
        .drawImage(image, 0, 0, canvas.width, canvas.height)

      resolve(canvas.toDataURL('image/jpeg'))
    }
    image.onerror = e => {
      reject(e)
    }
  })
}

export const arraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false
  for (let i = arr1.length; i--; ) {
    if (arr1[i] !== arr2[i]) return false
  }
  return true
}

export const getValidationsResult = ({
  component,
  passTrough,
  type = 'default'
}) => {
  const initialResult = { result: true, failedRule: null, errorMessage: null }

  if (!!component.validations && !!component.validations[type]) {
    const rules = passTrough ? [] : component.validations[type]
    const finalResult = rules.reduce(
      (res, rule) => {
        res.result = res.result && rule.validate && rule.validate(component)
        if (!res.result && !res.failedRule) {
          res.failedRule = rule
        }
        return res
      },
      { result: true, failedRule: null }
    )

    if (!finalResult.result) {
      if (!finalResult.failedRule.getErrorMessage) {
        finalResult.errorMessage = `${component.cleanName.toLowerCase()} non è valido`
      } else {
        finalResult.errorMessage = finalResult.failedRule.getErrorMessage(
          component
        )
      }
    }

    return finalResult
  } else {
    return initialResult
  }
}

/**
 * Removes diacritics from the provided string
 * @param  {string} str input string
 * @return {string}     output string
 */
export const removeDiacritics = str => {
  const defaultDiacriticsRemovalMap = [
    {
      base: 'A',
      letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
    },
    { base: 'AA', letters: /[\uA732]/g },
    { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g },
    { base: 'AO', letters: /[\uA734]/g },
    { base: 'AU', letters: /[\uA736]/g },
    { base: 'AV', letters: /[\uA738\uA73A]/g },
    { base: 'AY', letters: /[\uA73C]/g },
    {
      base: 'B',
      letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
    },
    {
      base: 'C',
      letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
    },
    {
      base: 'D',
      letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
    },
    { base: 'DZ', letters: /[\u01F1\u01C4]/g },
    { base: 'Dz', letters: /[\u01F2\u01C5]/g },
    {
      base: 'E',
      letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
    },
    { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
    {
      base: 'G',
      letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
    },
    {
      base: 'H',
      letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
    },
    {
      base: 'I',
      letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
    },
    { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
    {
      base: 'K',
      letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
    },
    {
      base: 'L',
      letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
    },
    { base: 'LJ', letters: /[\u01C7]/g },
    { base: 'Lj', letters: /[\u01C8]/g },
    {
      base: 'M',
      letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
    },
    {
      base: 'N',
      letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
    },
    { base: 'NJ', letters: /[\u01CA]/g },
    { base: 'Nj', letters: /[\u01CB]/g },
    {
      base: 'O',
      letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
    },
    { base: 'OI', letters: /[\u01A2]/g },
    { base: 'OO', letters: /[\uA74E]/g },
    { base: 'OU', letters: /[\u0222]/g },
    {
      base: 'P',
      letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
    },
    { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
    {
      base: 'R',
      letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
    },
    {
      base: 'S',
      letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
    },
    {
      base: 'T',
      letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
    },
    { base: 'TZ', letters: /[\uA728]/g },
    {
      base: 'U',
      letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
    },
    {
      base: 'V',
      letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
    },
    { base: 'VY', letters: /[\uA760]/g },
    {
      base: 'W',
      letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
    },
    { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
    {
      base: 'Y',
      letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
    },
    {
      base: 'Z',
      letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
    },
    {
      base: 'a',
      letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
    },
    { base: 'aa', letters: /[\uA733]/g },
    { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g },
    { base: 'ao', letters: /[\uA735]/g },
    { base: 'au', letters: /[\uA737]/g },
    { base: 'av', letters: /[\uA739\uA73B]/g },
    { base: 'ay', letters: /[\uA73D]/g },
    {
      base: 'b',
      letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
    },
    {
      base: 'c',
      letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
    },
    {
      base: 'd',
      letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
    },
    { base: 'dz', letters: /[\u01F3\u01C6]/g },
    {
      base: 'e',
      letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
    },
    { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
    {
      base: 'g',
      letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
    },
    {
      base: 'h',
      letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
    },
    { base: 'hv', letters: /[\u0195]/g },
    {
      base: 'i',
      letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
    },
    { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
    {
      base: 'k',
      letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
    },
    {
      base: 'l',
      letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
    },
    { base: 'lj', letters: /[\u01C9]/g },
    {
      base: 'm',
      letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
    },
    {
      base: 'n',
      letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
    },
    { base: 'nj', letters: /[\u01CC]/g },
    {
      base: 'o',
      letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
    },
    { base: 'oi', letters: /[\u01A3]/g },
    { base: 'ou', letters: /[\u0223]/g },
    { base: 'oo', letters: /[\uA74F]/g },
    {
      base: 'p',
      letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
    },
    { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
    {
      base: 'r',
      letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
    },
    {
      base: 's',
      letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
    },
    {
      base: 't',
      letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
    },
    { base: 'tz', letters: /[\uA729]/g },
    {
      base: 'u',
      letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
    },
    {
      base: 'v',
      letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
    },
    { base: 'vy', letters: /[\uA761]/g },
    {
      base: 'w',
      letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
    },
    { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
    {
      base: 'y',
      letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
    },
    {
      base: 'z',
      letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
    }
  ]

  str = str.replace(/([À-ž]$|([À-ž](?=\s)))/g, "$1'")

  for (let i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(
      defaultDiacriticsRemovalMap[i].letters,
      defaultDiacriticsRemovalMap[i].base
    )
  }

  return str
}

/**
 * Removes extra whitespaces and diacritics from the provided string
 * @param  {string} str input string
 * @return {string}     output string
 */
export const cleanupString = str => {
  const res =
    str &&
    str
      .replace('€ ', '')
      .trim()
      .replace(/\s\s+/g, ' ')
      .replace(/\s*\-\s*/, '-')
  if (/\s$/.test(res) || /^\s/.test(res) || /[À-ž]/.test(res)) {
    return removeDiacritics(res)
  }
  return res
}

export const getFlowRawValue = (partnership, convention) => {
  return `${partnership.toLowerCase()}${(!!convention && convention !== 'ND'
    ? '-' + convention
    : ''
  ).toLowerCase()}`
}

export const getPartnershipAndConventionFromRawValue = rawValue => {
  rawValue = rawValue.toUpperCase()

  const regex = /([^\/\-]+)\-?([^\/]*).*/i

  const defaultPartnership = 'POS_AZIENDA_EASYNOLO'
  const defaultConvention = 'ND'

  let partnership = defaultPartnership
  let convention = defaultConvention

  if (!!rawValue) {
    partnership = rawValue.replace(regex, '$1')
    convention = rawValue.replace(regex, '$2') || defaultConvention

    /*if (
      rawValue === 'POS_PERSONA_FISICA_EASYNOLO' ||
      rawValue === 'POS_DITTA_IND_EASYNOLO' ||
      rawValue === 'POS_AZIENDA_EASYNOLO'
    ) {
      partnership = defaultPartnership
    }*/

    /*if (rawValue === 'HYPEYOOX') {
      convention = 'YOOX'
    }

    if (rawValue === 'ADECCO') {
      convention = 'ADECCO'
    }*/
  }

  return { partnership, convention }
}

export const getPartnershipAndConventionFromUrl = payload => {
  const regex = new RegExp(
    `${CONTEXT_ROOT.replace('/', '\\/')}\\/[^\\/]+\\/([^\\/]+).*`,
    'i'
  )

  const defaultPartnership = 'POS_AZIENDA_EASYNOLO'
  const defaultConvention = 'ND'

  const partnership = defaultPartnership
  const convention = defaultConvention

  if (regex.test(payload.pathname)) {
    return getPartnershipAndConventionFromRawValue(
      payload.pathname.replace(regex, '$1')
    )
  }

  return { partnership, convention }
}

export const getHelpdeskMail = ({ partnership, convention }) => {
  if (partnership === 'HYPE4TIM') return 'timpersonal@hype.it'

  if (partnership === 'HYPE' && convention === 'YOOX') return 'yooxcard@hype.it'

  return 'hello@hype.it'
}

export const getLinkFoglioInformativo = ({ partnership, convention }) => {
  if (partnership === 'HYPE4TIM')
    return 'https://www.hype.it/SSRDocumentDisplayer?dtdPG=B26_BSE&dtdPE=1'

  if (partnership === 'HYPE' && convention === 'YOOX')
    return 'https://www.hype.it/SSRDocumentDisplayer?dtdPG=FI_HYPE_YOOX&dtdPE=1'

  return 'https://www.hype.it/SSRDocumentDisplayer?dtdPG=FI_HYPE_START&dtdPE=1'
}

const compareDomNodePosition = (a, b) => {
  if (a === b) return 0
  if (!a.compareDocumentPosition) {
    // support for IE8 and below
    return a.sourceIndex - b.sourceIndex
  }
  if (a.compareDocumentPosition(b) & 2) {
    // b comes before a
    return 1
  }
  return -1
}

const getDomNodeDistances = element => {
  let xPosition = 0
  let yPosition = 0

  while (element) {
    xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft
    yPosition += element.offsetTop - element.scrollTop + element.clientTop
    element = element.offsetParent
  }

  return { x: xPosition, y: yPosition }
}

export const scrollToFirstInvalidComponent = components => {
  // if (!!document.activeElement && document.activeElement.id === 'bt-next') {
    const invalidComponentKeys = Object.keys(components)
      .filter(k => isEntityInvalid(k, components))
      .sort((a, b) => {
        return (components[a].position || 0) - (components[b].position || 0)
      })

    let nodes = (invalidComponentKeys || []).map(
      k => document.querySelectorAll(`[name="${k}"]`)[0]
    )

    if (nodes.length === 0) {
      nodes = (invalidComponentKeys || []).map(
        k => document.querySelectorAll(`[name^="${k}"]`)[0]
      )
    }

    if (nodes.length > 0) {
      nodes = nodes.sort(compareDomNodePosition)

      window.scrollTo(0, getDomNodeDistances(nodes[0]).y - 50)
    }
  //}
}



// WEBPACK FOOTER //
// ./utils.js